import { Schema, Effect } from "effect";
import { describeIntRange } from "../openapi-query.js";

import { LegalEntitySourceFacts } from "./legal-entity-source-facts.js";

const observationMetadata = {
  orgnr: Schema.String,
  firstObservedAt: Schema.String,
  lastObservedAt: Schema.String,
  observedAt: Schema.String,
  validFrom: Schema.String,
  validTo: Schema.NullOr(Schema.String),
  captureRunId: Schema.String,
};

/** Observed source availability, independent of company operating status. */
export const CompanyRegisterObservation = Schema.Union([
  Schema.Struct({
    ...observationMetadata,
    lookupStatus: Schema.Literal("found"),
    sourceFacts: LegalEntitySourceFacts,
  }),
  Schema.Struct({
    ...observationMetadata,
    lookupStatus: Schema.Literal("not_found"),
    sourceFacts: Schema.Null,
  }),
]);

export const CompanyRegisterFactsQuery = Schema.Struct({
  offset: Schema.NumberFromString.pipe(
    Schema.check(Schema.isInt()),
    Schema.check(Schema.isGreaterThanOrEqualTo(0)),
    Schema.check(Schema.isLessThanOrEqualTo(Number.MAX_SAFE_INTEGER)),
    describeIntRange({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER })
  ).pipe(
    Schema.withDecodingDefaultType(Effect.sync(() => 0)),
    Schema.withConstructorDefault(Effect.sync(() => 0))
  ),
  limit: Schema.NumberFromString.pipe(
    Schema.check(Schema.isInt()),
    Schema.check(Schema.isGreaterThan(0)),
    Schema.check(Schema.isLessThanOrEqualTo(100)),
    describeIntRange({ minimum: 1, maximum: 100 })
  ).pipe(
    Schema.withDecodingDefaultType(Effect.sync(() => 20)),
    Schema.withConstructorDefault(Effect.sync(() => 20))
  ),
});

export const CompanyRegisterFactsResponse = Schema.Struct({
  current: Schema.NullOr(CompanyRegisterObservation),
  versions: Schema.Array(CompanyRegisterObservation),
  totalVersions: Schema.Int.pipe(Schema.check(Schema.isGreaterThanOrEqualTo(0))),
  offset: Schema.Int.pipe(Schema.check(Schema.isGreaterThanOrEqualTo(0))),
  limit: Schema.Int.pipe(Schema.check(Schema.isGreaterThan(0))),
  hasMore: Schema.Boolean,
  source: Schema.Struct({
    key: Schema.Literal("scb_afr_legal_entities"),
    label: Schema.Literal("SCB Company Registry"),
  }),
});
